import React, { Component } from 'react';

class CheckBoxInputField extends Component {
    
    toggleCheckboxChange = () => {
        if(!this.props.disabled) {
            this.props.onChange(this.props.field, !this.props.checked);
        }
    }

    render() {

        const extraClass = this.props.hasError ? 'is-invalid' : 'form-control';
        var ischecked = false;
        if(this.props.checked === true || this.props.checked === "true" || this.props.checked === 1){
            ischecked = true;
        }
        return (
            <div className="checkbox-group" onClick={this.toggleCheckboxChange} >
                
                <input
                    className={`${extraClass}`}
                    id={`${this.props.field}_field`}
                    type="checkbox"
                    value={ this.props.label }      
                    checked={ ischecked }
                    disabled={ this.props.disabled }
                />  
                    
                <label>
                    {this.props.label}    
                </label>
            </div>
        );
    }
}

export default (CheckBoxInputField);
